import { ApolloLink } from '@apollo/client';
import { Observable } from '@apollo/client/utilities';
import { store } from '../../store';
import { logError } from '../../utils/errorDispatchers';
import { mapErrorToType } from '../../utils/errorMapper';

/**
 * Global Apollo Link for intercepting API errors.
 */
const errorInterceptor = new ApolloLink((operation, forward) => {
  return new Observable((observer) => {
    const subscription = forward(operation).subscribe({
      next: (result) => observer.next(result),
      error: (error) => {
        // Map the error to a user-friendly type and message
        const mappedError = mapErrorToType(error);

        // Log the error to Redux
        logError(store.dispatch, {
          ...mappedError,
          component: 'GlobalInterceptor',
        });

        // Pass the error to the observer
        observer.error(error);
      },
      complete: () => observer.complete(),
    });

    // Cleanup the subscription
    return () => {
      if (subscription) subscription.unsubscribe();
    };
  });
});

// Add a global offline listener for real-time offline detection
window.addEventListener('offline', () => {
  const offlineError = mapErrorToType({ message: 'Offline Error' });
  logError(store.dispatch, {
    ...offlineError,
    component: 'GlobalOfflineListener',
  });
});

export default errorInterceptor;
